"use client";

import React from "react";
import { MapPin, Phone, Mail, Clock, Navigation } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VisitOurOffice() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const address = "Denver, Colorado, United States";
  const mapQuery = encodeURIComponent(address);
  const mapUrl = `https://maps.google.com/?q=${mapQuery}`;
  return <section data-section-id="223169" id="serving-the-denver-metro" className="bg-background text-foreground relative w-full h-[700px] md:h-[800px] overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-cover bg-center opacity-60 mix-blend-multiply" style={{
        backgroundImage: 'url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670428/img/denver_metro_architectural_map.png)'
      }} />
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-background/95 via-background/60 to-transparent md:w-2/3" />
      </div>

      {}
      <div className="container mx-auto px-4 relative z-10 h-full flex items-center">
        <div ref={ref} className={`w-full max-w-md transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <Card className="bg-card/90 backdrop-blur-lg border-border shadow-4xl">
            <CardHeader className="pb-4">
              <CardTitle className="text-3xl font-default text-primary tracking-tight">
                Serving the Denver Metro
              </CardTitle>
              <CardDescription className="text-base text-muted-foreground mt-2 font-default">BT Remodeling brings high-end craftsmanship and architectural precision to your doorstep at a price that's affordable.</CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="bg-secondary/10 p-2 rounded-md shrink-0 mt-0.5">
                  <MapPin className="w-5 h-5 text-secondary" />
                </div>
                <div>
                  <h4 className="font-semibold font-default text-foreground mb-1">Service Areas</h4>
                  <p className="text-muted-foreground leading-relaxed font-default">Greater Denver Metro Area</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-secondary/10 p-2 rounded-md shrink-0 mt-0.5">
                  <Phone className="w-5 h-5 text-secondary" />
                </div>
                <div>
                  <h4 className="font-semibold font-default text-foreground mb-1">Direct Line</h4>
                  <p className="text-muted-foreground font-default">
                    <Link to="tel:+13035550199" className="hover:text-secondary transition-colors">(720) 410-0886</Link>
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-secondary/10 p-2 rounded-md shrink-0 mt-0.5">
                  <Mail className="w-5 h-5 text-secondary" />
                </div>
                <div>
                  <h4 className="font-semibold font-default text-foreground mb-1">Inquiries</h4>
                  <p className="text-muted-foreground font-default">
                    <Link to="mailto:build@btremodeling.com" className="hover:text-secondary transition-colors">Info@BTRemodeling.com</Link>
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-secondary/10 p-2 rounded-md shrink-0 mt-0.5">
                  <Clock className="w-5 h-5 text-secondary" />
                </div>
                <div>
                  <h4 className="font-semibold font-default text-foreground mb-1">Consultation Hours</h4>
                  <ul className="text-muted-foreground space-y-1 font-default">
                    <li>Mon - Fri: 8:00am - 6:00pm</li>
                    <li>Sat: By Appointment Only</li>
                    <li>Sun: Closed</li>
                  </ul>
                </div>
              </div>
            </CardContent>
            <CardFooter className="pt-2 pb-8">
              <Button asChild size="lg" className="w-full text-base bg-primary text-primary-foreground hover:bg-secondary transition-all rounded-md">
                <Link to={mapUrl} newTab>
                  <Navigation className="w-5 h-5 mr-2" />
                  View Service Map
                </Link>
              </Button>
            </CardFooter>
          </Card>
        </div>
      </div>
    </section>;
}